import React from 'react';
import { Typography, FormGroup } from '@material-ui/core';
import './css/SideBox.css';
import CheckItem from './CheckItem';
import IndeterminateItem from './IndeterminateItem';

//made this to test
const backupLinks = [
  "https://www.un.org/development/desa/disabilities/convention-on-the-rights-of-persons-with-disabilities/article-4-general-obligations.html",
  "https://www.un.org/development/desa/disabilities/convention-on-the-rights-of-persons-with-disabilities/article-7-children-with-disabilities.html",
  "https://www.un.org/development/desa/disabilities/convention-on-the-rights-of-persons-with-disabilities/article-9-accessibility.html",
  "http://www.un.org/development/desa/disabilities/convention-on-the-rights-of-persons-with-disabilities/article-19-living-independently-and-being-included-in-the-community.html",
  "http://www.un.org/development/desa/disabilities/convention-on-the-rights-of-persons-with-disabilities/article-20-personal-mobility.html",
  "http://www.un.org/development/desa/disabilities/convention-on-the-rights-of-persons-with-disabilities/article-23-respect-for-home-and-the-family.html",
  "https://www.un.org/development/desa/disabilities/convention-on-the-rights-of-persons-with-disabilities/article-25-health.html",
  "http://www.un.org/development/desa/disabilities/convention-on-the-rights-of-persons-with-disabilities/article-26-habilitation-and-rehabilitation.html",
  "http://www.un.org/development/desa/disabilities/convention-on-the-rights-of-persons-with-disabilities/article-27-work-and-employment.html",
  "http://www.un.org/development/desa/disabilities/convention-on-the-rights-of-persons-with-disabilities/article-28-adequate-standard-of-living-and-social-protection.html"
];

//required because of the way the uncrpd data is arranged, I cant get program names from ones that aren't covered by the province.
//may change data later, but currently this allows testing faster
const progNames = [
  "General Obligations",
  "Children with disabilities",
  "Accessibility",
  "Living independently and being included in the community",
  "Personal mobility",
  "Respect for home and the family",
  "Health",
  "Habilitation and rehabilitation",
  "Work and employment",
  "Adequate standard of living and social protection"
]


//The following works assuming the data input is in sorted order.
function generateCheck(data){
  //list of all articels to check against
  const checkList = [4, 7, 9, 19, 20, 23, 25, 26, 27, 28];
  const retList = [];//array of components to return
  let innerList=[];//array of checkboxes, to be wrapped in "FormGroup"
  let data_i = 0;//index to iterate through input data
  let check_i = 0;//index to iterat through checklist
  let checkbox;//holds component

  for(check_i=0; check_i < checkList.length; check_i++){
    let fullLink = (url, text) => (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {text}
      </a>
    );//function to create hyperlink
    if (data[data_i].number === checkList[check_i]) {//if article is true/exists
      checkbox = (
        <CheckItem 
          key={backupLinks[check_i]} 
          link={fullLink(backupLinks[check_i], data[data_i].name)} 
          programs={data[data_i].programs} 
          number={checkList[check_i]}
        />
      );
      innerList.push(checkbox);
      data_i++;//increment data index
    }
    else {//if article false
      checkbox = (
        <IndeterminateItem 
          key={backupLinks[check_i]} 
          link={fullLink(backupLinks[check_i], progNames[check_i])} 
          number= {checkList[check_i]}
        />
      );
      innerList.push(checkbox);
    }
  }
  retList.push(<FormGroup key={"FormGroup Wrapper"} >{innerList}</FormGroup>);//wrap in "FormGroup"
  return retList;
}


export default function ArticleCollection({data}) {
  const showEmpty = <div>Data Currently Unavailable</div>;
  let articles;
  if(data){
    articles = data.articleList;
  }

  const checkEmpty = () =>{
    if (articles) return generateCheck(articles);
    else return showEmpty;
  };

  return (
    <div className="uncrpdContainer">
      <Typography 
      variant="h6" 
      align="center">
          UN CRPD Articles Met<br/>as of 2018:
      </Typography>
      <div className="articleContainer">
        {checkEmpty()}
      </div>
    </div>
  );
}